import type { ThemeConfig } from "antd";
import { theme } from "antd";

const config: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#0886CF',
    colorInfo: '#ff6645',
    colorError: 'b81414',
    colorText: "#000000",
    boxShadow: '0 4px 24px 0 rgba(34, 41, 47, 0.1)',
    colorFillSecondary: '#ffffff',
  },
};

export default config;
